export default {
      id: "close-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#close",
      toString: function () {
        return this.url;
      }
    }